<template>
    <div class="room_type_component">
        <el-drawer title="房型配置" :visible.sync="isShow" size="900px" @close="$emit('close')">
            <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch" label-width="90px">
                <el-form-item label="房型名称" prop="name">
                    <el-input v-model="searchForm.name" placeholder="房型名称" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                    <el-button @click="handleReset" size="small">重置</el-button>
                </el-form-item>
            </el-form>
            <div style="padding-bottom: 10px">
                <el-button icon="el-icon-plus" type="primary" size="small" @click="handleAdd">新增房型</el-button>
                <el-button icon="el-icon-plus" plain size="small" @click="handleReorder">退订</el-button>
            </div>

            <el-table border size="small" style="width: 100%; margin-top: 10px" :data="tableData" v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <el-table-column type="index" label="#" align="center"></el-table-column>
                <el-table-column prop="name" label="房型名称" width="120"></el-table-column>
                <el-table-column prop="defaultPrice" label="默认价" width="120"></el-table-column>
                <el-table-column prop="enterprisePrice" label="企业价" width="120"></el-table-column>
                <el-table-column prop="openStatus" label="分销模式" width="120">
                    <template slot-scope="{ row }">
                        <el-tag type="success" size="mini" v-if="row.openStatus == 1">启用</el-tag>
                        <el-tag type="danger" size="mini" v-else>禁用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="120">
                    <template slot-scope="{ row }">
                        <el-tag type="success" size="mini" v-if="row.status == 1">启用</el-tag>
                        <el-tag type="danger" size="mini" v-else>禁用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" align="center" width="150">
                    <template slot-scope="{ row }">
                        <el-button size="mini" type="text" @click="handleEdit(row)">编辑</el-button>
                        <el-button size="mini" type="text" style="color: red" @click="handleDelete(row)">删除</el-button>
                        <el-dropdown trigger="click">
                            <span style="padding: 0 10px;cursor: pointer;margin-left: 10px;">
                                <i class="el-icon-more"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>
                                    <div @click="handleSetRetail(row)">设置分销</div>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <div @click="handleSetPrice(row)">房型价格</div>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage" style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total"></el-pagination>
        </el-drawer>

        <el-dialog :visible.sync="isAdd" :title="!modelForm.id ? '添加' : '编辑'" width="820px" append-to-body destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false">
            <el-form ref="modelForm" :model="modelForm" inline label-width="110px" class="room_type_container" style="margin: 0 20px" size="small" :rules="modelFormRules">
                <el-divider content-position="left">基础信息</el-divider>
                <el-form-item label="房型名称" prop="name">
                    <el-input type="text" v-model="modelForm.name" placeholder="请输入房型名称" style="width: 240px"></el-input>
                </el-form-item>
                <el-form-item label="简称" prop="shortName">
                    <el-input type="text" v-model="modelForm.shortName" placeholder="请输入简称名用于顾客筛选" style="width: 240px"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input type="text" v-model="modelForm.sort" placeholder="请输入排序" style="width: 240px"></el-input>
                </el-form-item>
                <el-form-item label="最大入住人数" prop="maxLoad">
                    <el-input type="text" v-model="modelForm.maxLoad" placeholder="请输入最大入住人数" style="width: 240px"></el-input>
                </el-form-item>
                <el-form-item label="房型面积" prop="roomArea">
                    <el-input v-model="modelForm.roomArea" placeholder="请输入房型面积" style="width: 240px">
                        <span slot="append">㎡</span>
                    </el-input>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-radio-group v-model="modelForm.status" style="width: 240px">
                        <el-radio :label="1">启用</el-radio>
                        <el-radio :label="0">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-divider content-position="left">展示信息</el-divider>

                <el-form-item prop="roomPictureUrl" label="房间图片">
                    <div class="detail_container">
                        <div class="detail_item" v-for="(item, key) in modelForm.roomPictureUrl" :key="key">
                            <img :src="item" style="width: 150px" />
                            <div class="image_button">
                                <i class="el-icon-zoom-in" @click="handleShowImage(item)"></i>
                                <i class="el-icon-delete" @click="handleDeleteImage(key)"></i>
                            </div>
                        </div>
                        <el-upload v-if="modelForm.roomPictureUrl.length < 5" class="image-uploader" action="/room/upload/img" :headers="headers" name="mulFile" :data="{ key: 'head' }" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                            <div class="image-uploader-icon">
                                <i class="el-icon-plus"></i>
                                <span>上传图片</span>
                            </div>
                            <div slot="tip" class="el-upload__tip" style="width: 240px;line-height: 20px;font-size: 11px;color: #999999;">
                                支持jpg .jpeg .bmp
                                .png格式，大小不超过2M，最多上传5张，建议尺寸：750px * 375px
                            </div>
                        </el-upload>
                    </div>
                </el-form-item>
                <div class="line"></div>
                <el-form-item label="是否有窗" prop="haveWindow">
                    <el-radio-group v-model="modelForm.haveWindow" style="width: 240px">
                        <el-radio :label="1">有</el-radio>
                        <el-radio :label="0">无</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否含早" prop="haveBreakfast">
                    <el-radio-group v-model="modelForm.haveBreakfast" style="width: 240px">
                        <el-radio :label="1">含早</el-radio>
                        <el-radio :label="0">不含</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否禁烟" prop="haveSmoke">
                    <el-radio-group v-model="modelForm.haveSmoke" style="width: 240px">
                        <el-radio :label="0">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="加床" prop="extraBed">
                    <el-radio-group v-model="modelForm.extraBed" style="width: 240px">
                        <el-radio :label="0">不允许</el-radio>
                        <el-radio :label="1">允许</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="预定说明" prop="explainConfiguration">
                    <el-input type="textarea" v-model="modelForm.explainConfiguration" placeholder="请输入预定说明" :autosize="{ minRows: 3, maxRows: 6}" style="width: 500px"></el-input>
                </el-form-item>

                <el-divider content-position="center">配套服务<span style="margin-left:12px"><el-button type="primary" size="mini" @click="handleCheckAll">全选</el-button><el-button plain size="mini" @click="handleClear">清空</el-button></span></el-divider>
                <div class="serv-item">
                    <div class="title">
                        <img src="https://test.file.nofetel.com/dffile/2023%5C11%5C29%5C08e5fb26-2ece-4fbc-a780-1451d0b4048f.png" alt="" />
                        <span>洗浴用品</span>
                    </div>

                    <el-checkbox-group v-model="modelForm.rushroomSupporting" size="small">
                        <el-checkbox :label="item.value" v-for="(item, key) in dicData1" :key="key"></el-checkbox>
                    </el-checkbox-group>
                </div>

                <div class="serv-item">
                    <div class="title">
                        <img src="https://test.file.nofetel.com/dffile/2023%5C11%5C29%5Cb75fc579-6779-4484-99f6-89c52ec60df3.png" alt="" />
                        <span>便利设施</span>
                    </div>
                    <el-checkbox-group v-model="modelForm.amenities" size="small">
                        <el-checkbox :label="item.value" v-for="(item, key) in dicData2" :key="key"></el-checkbox>
                    </el-checkbox-group>
                </div>

                <div class="serv-item">
                    <div class="title">
                        <img src="https://test.file.nofetel.com/dffile/2023%5C11%5C29%5C73c1e16c-a939-43b8-a8f0-e4ea377cf3b2.png" alt="" />
                        <span>媒体科技</span>
                    </div>
                    <el-checkbox-group v-model="modelForm.media" size="small">
                        <el-checkbox :label="item.value" v-for="(item, key) in dicData3" :key="key"></el-checkbox>
                    </el-checkbox-group>
                </div>

                <div class="serv-item">
                    <div class="title">
                        <img src="https://test.file.nofetel.com/dffile/2023%5C11%5C29%5Ccf1d1e5e-ceda-457e-bdae-fdbec3919f42.png" alt="" />
                        <span>浴室</span>
                    </div>
                    <el-checkbox-group v-model="modelForm.bath" size="small">
                        <el-checkbox :label="item.value" v-for="(item, key) in dicData4" :key="key"></el-checkbox>
                    </el-checkbox-group>
                </div>
            </el-form>
            <div class="footer" style="margin: 0 20px; text-align: right">
                <el-button type="text" @click="isAdd = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit('modelForm')">提交</el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="isView" title="图片" width="500px" append-to-body destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false">
            <div style="text-align: center">
                <img :src="imgUrl" alt="" style="max-height: 150px; max-width: 400px" />
            </div>

            <div slot="footer">
                <el-button size="small" type="primary" @click="isView = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 退订 -->
        <el-dialog :visible.sync="isReset" title="退订设置" width="650px" append-to-body destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false">
            <el-form ref="cancelForm" :model="cancelForm" label-width="90px" style="margin: 0 20px" size="small">
                <el-form-item label="退订规则" prop="refundType" :rules="[{ required: true, message: '请选择退订规则'}]">
                    <el-tooltip placement="top" style="margin-right: 10px">
                        <div slot="content" style="line-height:20px">
                            说明：设置顾客最迟取消订单时间，超时将不允许顾客取消订单
                        </div>
                        <i class="el-icon-question" style="font-size:16px"></i>
                    </el-tooltip>
                    <el-radio-group v-model="cancelForm.refundType" style="width: 400px">
                        <el-radio :label="0">不可取消</el-radio>
                        <el-radio :label="1">入住前(免审核)</el-radio>
                        <el-radio :label="2">入住前(需审核)</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label=" ">
                    <div class="tips">
                        <span v-if="cancelForm.refundType == 0">顾客支付后不可主动取消订单，需联系酒店进行退款。订房款将自动到酒店账户。</span>
                        <span v-if="cancelForm.refundType == 1">顾客未办理入住前均可主动取消订单，不需要审核，系统自动退款办理入住后不可主动取消订单，订房款将自动到酒店账户。</span>
                        <span v-if="cancelForm.refundType == 2">顾客未办理入住前均可主动取消订单，需要审核，审核通过系统自动退款。办理入住后不可主动取消订单，订房款将自动到酒店账户。</span>
                    </div>
                </el-form-item>
            </el-form>
            <div class="footer" style="margin: 0 20px; text-align: right">
                <el-button type="text" @click="isReset = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmitCancelForm('cancelForm')">确认</el-button>
            </div>
        </el-dialog>
        <!-- 设置分销 -->
        <el-dialog :visible.sync="isSetRestail" title="设置分销" width="500px" append-to-body destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false">
            <el-form ref="restailForm" :model="restailForm" inline label-width="110px" style="margin: 0 20px" size="small" :rules="restailFormRules">
                <el-form-item label="分销类型" prop="type">
                    <el-radio-group v-model="restailForm.type" style="width: 240px">
                        <el-radio :label="0">固定金额</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="分销金额" prop="money">
                    <el-input type="text" v-model="restailForm.money" placeholder="请输入分销金额" style="width: 240px"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="openStatus">
                    <el-radio-group v-model="restailForm.openStatus" style="width: 240px">
                        <el-radio :label="1">开启</el-radio>
                        <el-radio :label="0">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div class="footer" style="margin: 0 20px; text-align: right">
                <el-button type="text" @click="isSetRestail = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmitRetail('restailForm')">设置</el-button>
            </div>
        </el-dialog>
        <el-drawer title="房型价格配置" :visible.sync="isShowPrice" size="900px" @close="isShowPrice =false">
            <el-form ref="priceForm" :model="priceForm" inline label-width="120px" style="margin: 0 20px" size="small" :rules="rulesForm">
                <el-form-item label="普通价格" prop="defaultPrice">
                    <el-input type="text" v-model="priceForm.defaultPrice" placeholder="请输入" style="width: 240px"></el-input>
                </el-form-item>
                <el-form-item label="企业价格" prop="enterprisePrice">
                    <el-input type="text" v-model="priceForm.enterprisePrice" placeholder="请输入" style="width: 240px"></el-input>
                </el-form-item>
                <el-form-item label="时段价" prop="openPeriod">
                    <el-switch v-model="priceForm.openPeriod" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-divider v-if="priceForm.openPeriod == 1" content-position="left"><el-button type="primary" size="mini" @click="handleAddList('priceForm')">添加特殊价格</el-button></el-divider>
                <el-table v-if="priceForm.openPeriod == 1" ref="multipleTable2" size="small" border style="margin-top:10px;" :data="priceForm.list" :span-method="arraySpanMethod">
                    <el-table-column label="时间" align="center">
                        <template slot-scope="{row}">
                            <span>{{ row.startTime }}至{{row.endTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="默认房价" prop="defaultPrice" align="center"></el-table-column>
                    <el-table-column label="企业房价" prop="enterprisePrice" align="center"></el-table-column>
                    <el-table-column label="备注" prop="remarks" align="center"></el-table-column>
                    <el-table-column label="操作" fixed="right" align="center">
                        <template slot-scope="{row, $index}">
                            <el-button size="mini" type="text" @click="handleEditPrize(row,$index)">编辑</el-button>
                            <el-button size="mini" type="text" style="color: red" @click="handleDeleteTime(row,$index)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
            <div class="footer" style="margin: 20px 20px; text-align: right">
                <el-button type="text" @click="isShowPrice = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handlePrice('priceForm')">确认</el-button>
            </div>
        </el-drawer>
        <el-dialog :visible.sync="openForm" title="设置时段价格" width="800px" append-to-body destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false">
            <el-form ref="setForm" :model="setForm" inline label-width="100px" label-position="right" style="margin: 0 20px" size="small" :rules="rulesForm">
                <el-form-item label="时间">
                    <el-date-picker v-model="selectTime" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd" :clearable="false" key="picker1" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 230px"
                        @change="handleChangeDate($event)"></el-date-picker>
                </el-form-item>
                <el-form-item label="普通价格" prop="defaultPrice">
                    <el-input v-model="setForm.defaultPrice" style="width: 230px" />
                </el-form-item>
                <el-form-item label="企业价格" prop="enterprisePrice">
                    <el-input v-model="setForm.enterprisePrice" style="width: 230px" />
                </el-form-item>
                <el-form-item label="备注" prop="remarks">
                    <el-input v-model="setForm.remarks" style="width: 230px" />
                </el-form-item>
            </el-form>
            <div class="footer" style="margin: 0 20px; text-align: right">
                <el-button type="text" @click="openForm = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmitPirce('setForm')">设置</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
import { deepClone } from '@/utils/util'
export default {
    props: {
        isRoomType: {
            type: Boolean,
            default: false,
        },
        hotelId: {
            type: String,
            default: null,
        },
    },
    computed: {
        headers() {
            return {
                Authorization: localStorage.getItem("Token"),
            };
        },
    },
    data() {
        const validatePrice = (rule, value, callback) => {
            if (
                (value < 0.01 && value) ||
                !value ||
                !/^\d+(\.\d{1,2})?$/.test(value)
            ) {
                callback(new Error("价格不能小于0.01元且最多只能保留两位小数"));
            } else {
                callback();
            }
        };

        const validateArea = (rule, value, callback) => {
            if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                callback(new Error("房型面积不能为空且最多只能保留两位小数"));
            } else {
                callback();
            }
        };
        const validateCount = (rule, value, callback) => {
            if (!/^\d+?$/.test(value)) {
                callback(new Error("入住人数只能输入整数"));
            } else {
                callback();
            }
        };

        const validateSort = (rule, value, callback) => {
            if (!/^\d+?$/.test(value)) {
                callback(new Error("排序值只能输入整数"));
            } else {
                callback();
            }
        };

        const validateImage = (rule, value, callback) => {
            if (value.length < 3 || value.length > 5) {
                callback(new Error("请上传房间图片不少于三张,最多五张"));
            } else {
                callback();
            }
        };
        return {
            restailForm: {
                roomTypeId: '',
                openStatus: 1,
                type: 0,
                money: ''
            },
            cancelForm: {
                refundType: 0
            },
            setForm: {

            },
            openForm: false,
            isReset: false,
            checkedAll: false,
            priceForm: {
                list: []
            },
            isShowPrice: false,
            isShow: false,
            isSetRestail: false,
            searchForm: {
                name: "",
                hotelId: this.hotelId,
                pageNumber: 1,
                pageSize: 10,
            },
            isLoading: false,
            tableData: [],
            total: 0,
            selectTime: [],
            isAdd: false,
            modelForm: {
                name: "",
                shortName: "",
                sort: "",
                maxLoad: "",
                roomArea: "",
                status: 1,
                chargingMode: 0,
                defaultPrice: "",
                showPrice: "",
                weekendPrice: "",
                roomPictureUrl: [],
                haveWindow: 1,
                haveBreakfast: 1,
                haveSmoke: 0,
                extraBed: 0,
                rushroomSupporting: [],
                amenities: [],
                media: [],
                bath: [],
                explainConfiguration: ""
            },
            restailFormRules: {
                openStatus: [{ required: true, message: "请选择状态", trigger: ['change', 'blur'] }],
                money: [
                    { required: true, validator: validatePrice, trigger: "blur" },
                ],
            },
            rulesForm: {
                defaultPrice: [
                    { required: true, validator: validatePrice, trigger: "blur" },
                ],
                enterprisePrice: [
                    { required: true, validator: validatePrice, trigger: "blur" },
                ]
            },
            modelFormRules: {
                name: [{ required: true, message: "请输入房型名称", trigger: "blur" }],
                shortName: [{ required: true, message: "请输入简称名用于顾客筛选", trigger: "blur", }],
                maxLoad: [
                    { required: true, validator: validateCount, trigger: "blur" },
                ],
                roomArea: [
                    { required: true, validator: validateArea, trigger: "blur" },
                ],
                defaultPrice: [
                    { required: true, validator: validatePrice, trigger: "blur" },
                ],
                enterprisePrice: [
                    { required: true, validator: validatePrice, trigger: "blur" },
                ],
                showPrice: [
                    { required: true, validator: validatePrice, trigger: "blur" },
                ],
                weekendPrice: [
                    { required: true, validator: validatePrice, trigger: "blur" },
                ],
                sort: [{ required: true, validator: validateSort, trigger: "blur" }],
                roomPictureUrl: [{ required: true, validator: validateImage, trigger: "blur" }],

            },
            checkedServices: [],
            dicData1: [],
            dicData2: [],
            dicData3: [],
            dicData4: [],

            isView: false,
            imgUrl: "",
            submitLoading: false,
        };
    },
    watch: {
        isRoomType(newVal) {
            this.isShow = !!newVal;
            if (!!newVal) {
                this.searchForm = {
                    name: "",
                    hotelId: this.hotelId,
                    pageNumber: 1,
                    pageSize: 10,
                };

                this.getRoomTypeList();
                this.getDictData();
            }
        },
    },
    methods: {
        handleReorder() {
            this.getRequest(`/api/hotel/get/${this.hotelId}`).then(res => {
                if (res.data.code == 200) {
                    this.cancelForm = res.data.data;
                    console.log(this.cancelForm)
                }
            }).finally(() => {
                this.isReset = true
            })
        },
        handleSubmitCancelForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                    this.cancelForm.id = this.hotelId;
                    this.postRequest("/api/hotel/editRefundType", this.cancelForm)
                        .then((res) => {
                            this.submitLoading = false;
                            let data = res.data;
                            if (data.code == 200) {
                                this.isReset = false;
                                this.cancelForm = {};
                                this.$message.success(data.msg);
                            }
                        })
                        .catch(() => {
                            this.submitLoading = false;
                        });
                }
            });
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === this.priceForm.list.length) {
                if (columnIndex === 0) {
                    return [1, 5];
                } else if (columnIndex === 1) {
                    return [0, 0];
                }
            }
        },
        handleShowImage(item) {
            this.isView = true;
            this.imgUrl = item;
        },
        handleSetPrice(item) {
            this.getRequest(`/api/roomTypePrice/getVo`, { roomTypeId: item.id }).then(res => {
                let data = res.data;
                if (data.code == 200 && data.data) {
                    this.priceForm = data.data;
                } else {
                    this.priceForm = {
                        roomTypeId: item.id,
                        defaultPrice: '',
                        enterprisePrice: '',
                        openPeriod: 1,
                        list: [{
                            startTime: '',
                            startTimeStr: '',
                            endTimeStr: '',
                            endTime: '',
                            defaultPrice: '',
                            enterprisePrice: '',
                            remarks: ''
                        }]
                    }
                }
            }).finally(err => {
                this.isShowPrice = true
            })
        },
        handlePrice(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                    this.postRequest("/api/roomTypePrice/save", this.priceForm)
                        .then((res) => {
                            this.submitLoading = false;
                            let data = res.data;
                            if (data.code == 200) {
                                this.$message.success(data.msg);
                                this.isShowPrice = false;
                                this.getRoomTypeList();
                            }
                        })
                        .catch(() => {
                            this.submitLoading = false;
                        });
                }
            });
        },
        handleAddList() {
            this.priceForm.list.push({
                defaultPrice: '',
                startTime: '',
                enterprisePrice: '',
                endTime: ''
            })
        },
        handleChangeDate(date) {
            console.log(date)
            if (date.length) {
                this.setForm.startTime = date[0];
                this.setForm.startTimeStr = date[0];
                this.setForm.endTimeStr = date[1];
                this.setForm.endTime = date[1];
                this.selectTime = [date[0],date[1]]
            } else {
                this.setForm.startTime = ''
                this.setForm.endTime = ''
                this.selectTime = [];
            }
        },
        handleSetRetail(row) {
            this.restailForm.roomTypeId = row.id;
            this.getRequest(`/df-profit/room/sln/getById`, { id: row.id }).then(res => {
                if (res.data.code == 200 && res.data.data.id) {
                    const { type, openStatus, money, id, roomTypeId } = res.data.data
                    this.restailForm = {
                        type, openStatus, money, roomTypeId, id
                    }
                } else {
                    this.restailForm = {
                        roomTypeId: row.id,
                        openStatus: 1,
                        type: 0,
                        money: ''
                    }
                }
            }).finally(() => {
                this.isSetRestail = true
            })
        },
        handleDeleteImage(key) {
            this.modelForm.roomPictureUrl.splice(key, 1);
        },
        handleEditPrize(item, index) {
            this.setForm = deepClone(item);
            this.selectTime = [item.startTime, item.endTime];
            this.setForm.index = index;
            this.openForm = true;
        },
        handleDeleteTime(item, index) {
            this.priceForm.list.splice(index, 1);
        },
        handleSubmitPirce(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (!this.selectTime.length) {
                        this.$message.error('请选择时间')
                        return
                    }
                    const { index, ...data } = this.setForm;
                    this.$set(this.priceForm.list, index, data)
                    this.priceForm.list[index] = data;
                    this.$nextTick(() => {
                        this.openForm = false;
                    })
                }
            });
        },
        handleAvatarSuccess(res) {
            this.modelForm.roomPictureUrl.push(res.data);
        },
        beforeAvatarUpload(file) {
            const isJPG =
                file.type === "image/jpeg" ||
                file.type === "image/jpe" ||
                file.type === "image/png" ||
                file.type === "image/bmp";
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error("上传头像图片只能是 JPG/JPEG/PNG/BMP 格式!");
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!");
            }
            return isJPG && isLt2M;
        },
        handleSubmitRetail(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                    this.postRequest("/df-profit/room/sln/setRoomSln", this.restailForm)
                        .then((res) => {
                            this.submitLoading = false;
                            let data = res.data;
                            if (data.code == 200) {
                                this.$message.success(data.msg);
                                this.isSetRestail = false;
                                this.restailForm = {
                                    roomTypeId: '',
                                    openStatus: 1,
                                    type: 0,
                                    money: ''
                                }
                                this.getRoomTypeList();
                            }
                        })
                        .catch(() => {
                            this.submitLoading = false;
                        });
                }
            });
        },
        handleSubmit(fromName) {
            this.$refs[fromName].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                    if (!this.modelForm.id) {
                        this.postRequest("/api/roomType/add", this.modelForm)
                            .then((res) => {
                                this.submitLoading = false;
                                let data = res.data;
                                if (data.code == 200) {
                                    this.$message.success(data.msg);
                                    this.isAdd = false;
                                    this.getRoomTypeList();
                                }
                            })
                            .catch(() => {
                                this.submitLoading = false;
                            });
                    } else {
                        this.postRequest("/api/roomType/modify", this.modelForm)
                            .then((res) => {
                                this.submitLoading = false;
                                let data = res.data;
                                if (data.code == 200) {
                                    this.$message.success(data.msg);
                                    this.isAdd = false;
                                    this.getRoomTypeList();
                                }
                            })
                            .catch(() => {
                                this.submitLoading = false;
                            });
                    }
                }
            });
        },
        handleAdd() {
            this.modelForm = {
                hotelId: this.hotelId,
                name: "",
                shortName: "",
                sort: "",
                maxLoad: "",
                roomArea: "",
                status: 1,
                chargingMode: 0,
                defaultPrice: "",
                showPrice: "",
                weekendPrice: "",
                roomPictureUrl: [],
                haveWindow: 1,
                haveBreakfast: 1,
                haveSmoke: 0,
                extraBed: 0,
                rushroomSupporting: [],
                amenities: [],
                media: [],
                bath: [],
                explainConfiguration: "酒店开票\n支持普通发票，可添加酒店微信或电话联系预约开票。\n\n使用规则\n直接消费，携带所有入住人的有效身份证办理入住，入住必须按照一人一证。\n如需提前入住或延时退房，请咨询商家。\n\n房型说明\n房型图片仅可代表其中部分房间作为预定参考，实际提供房型信息请以文字信息为准，如文字信息不全或包含多种情况，请提前与商家沟通确认后再下单预约"
            };
            this.isAdd = true;
        },
        handleEdit(row) {
            this.getRequest(`/api/roomType/get/${row.id}`).then((res) => {
                let data = res.data;
                if (data.code == 200) {
                    data.data.roomPictureUrl = data.data.roomPictureUrl || [];
                    data.data.rushroomSupporting = data.data.rushroomSupporting || [];
                    data.data.amenities = data.data.amenities || [];
                    data.data.media = data.data.media || [];
                    data.data.bath = data.data.bath || [];
                    this.modelForm = data.data;
                    this.isAdd = true;
                }
            });
        },
        handleDelete(item) {
            this.$confirm("确定将选择数据删除?", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.getRequest(`/api/roomType/delete/${item.id}`).then((res) => {
                    let data = res.data;
                    if (data.code == 200) {
                        this.$message.success("删除成功");
                        this.getRoomTypeList();
                    }
                });
            });
        },
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getRoomTypeList();
        },

        handleReset() {
            this.searchForm = {
                hotelId: this.hotelId,
                name: "",
                pageSize: 10,
                pageNumber: 1,
            };
            this.getRoomTypeList();
        },

        handleChangePage(page) {
            this.searchForm.pageNumber = page;
            this.getRoomTypeList();
        },

        handleChangeSize(size) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = size;
            this.getRoomTypeList();
        },
        getRoomTypeList() {
            this.isLoading = true;
            this.getRequest("/api/roomType/page", this.searchForm).then((res) => {
                let data = res.data;
                this.isLoading = false;
                if (data.code == 200) {
                    this.tableData = data.data.records;
                    this.total = data.data.total;
                }
            });
        },
        async getDictData() {
            let data1 = await this.getRequest(
                "/dictData/getDictDataByType?type=room_rushroom_supporting"
            );
            let data2 = await this.getRequest(
                "/dictData/getDictDataByType?type=amenities"
            );
            let data3 = await this.getRequest(
                "/dictData/getDictDataByType?type=room_media"
            );
            let data4 = await this.getRequest(
                "/dictData/getDictDataByType?type=room_bath"
            );

            data1 = data1.data;
            data2 = data2.data;
            data3 = data3.data;
            data4 = data4.data;
            this.dicData1 = data1.data;
            this.dicData2 = data2.data;
            this.dicData3 = data3.data;
            this.dicData4 = data4.data;
        },
        handleCheckAll() {
            this.modelForm.rushroomSupporting = this.dicData1.map(item => { return item.value });
            this.modelForm.amenities = this.dicData2.map(item => { return item.value });
            this.modelForm.media = this.dicData3.map(item => { return item.value });
            this.modelForm.bath = this.dicData4.map(item => { return item.value });
        },
        handleClear() {
            this.modelForm.rushroomSupporting = [];
            this.modelForm.amenities = [];
            this.modelForm.media = [];
            this.modelForm.bath = [];
        }
    },
};
</script>

<style lang="less">
.room_type_container {
    max-height: 500px;
    overflow-y: scroll;
}

.serv-item {
    padding-bottom: 15px;

    .title {
        display: flex;
        align-items: center;
        padding-bottom: 15px;
        font-size: 13px;
        color: #333;
        font-weight: bold;

        img {
            width: 18px;
            margin-right: 3px;
        }
    }

    .el-checkbox {
        width: 120px;
        margin-bottom: 5px;
    }
}
.tips {
    color: #999999;
    font-size: 14px;
}
</style>